var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-tabs',_vm._l((_vm.links),function(link,index){return _c('v-tab',{key:index},[_c('v-btn',{attrs:{"text":"","exact":"","to":link.path}},[_vm._v(_vm._s(link.name))])],1)}),1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }